<template>
  <div id="family_manu">
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <!-- <p class="ml-4 mb-5 mt-4 pf-menu-text">Choose the family statuses for each menu items. The menu will be available only for families with the selected statuses</p> -->
    <v-layout class="ml-4 mr-4 flex-column">
      <h3 class="mb-4">1. Family Content</h3>
      <v-layout wrap class="mb-3">
        <v-flex sm4><b class="pf-font-18">Content Type</b></v-flex>
        <v-flex sm7><b class="pf-font-18">Approval Status</b></v-flex>
      </v-layout>
      <v-layout wrap v-for="(contentSetting, i) in contentSettings" :key="i">
        <v-flex sm4 class="flex-align-center pf-menu-text pf-font-18">{{ i }}</v-flex>
        <v-flex sm7 class="flex-align-center pf-menu-text pf-font-18">
          <v-radio-group v-model="contentSettings[i]" row @change="changedData()">
            <v-radio
              v-for="(status, j) in approvalStatuses"
              :key="j"
              :label="`${status.text}`"
              :value="status.name"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
/* global session store  */
import swal from 'sweetalert2';
// import { mapGetters } from 'vuex';
import { getCollection, update } from '../../helpers/helpers';

export default {
  name: 'family_content',
  // components: {
  // },
  data: () => ({
    contentSettingsBackup: {},
    selectedData: false,
    approvalStatuses: [
      { name: 'None', text: 'No Review' },
      { name: 'Notify', text: 'Notify' },
      { name: 'Approve', text: 'Review & Approve' }
    ],
    contentSettings: {
      'Avatar': 'None',
      'Banner': 'None',
      'Blogs': 'None',
      'Letters': 'None',
      'Photos': 'None',
      'Videos': 'None'
    }
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  async created () {
    window.getApp.$emit('pageSubHeader', 'Family Content');

    if (this.Agency && this.Agency.family_content_approval && Object.keys(this.Agency.family_content_approval).length) {
      this.contentSettings = this.Agency.family_content_approval ? this.Agency.family_content_approval : this.contentSettings;
    }
    this.contentSettingsBackup = JSON.parse(JSON.stringify(this.contentSettings));
  },
  methods: {
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    reset () {
      this.contentSettings = JSON.parse(JSON.stringify(this.contentSettingsBackup));
      this.hideButtons();
    },
    async save () {
      this.selectedData = true;
      if (Object.keys(this.contentSettings).length) {
        this.Agency.family_content_approval = this.contentSettings;
      }
      let { error, data, status } = await update('Agency', this.Agency, this.Agency.id);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to update the data'
        };
      } else {
        swal.fire({
          type: 'success',
          title: 'Family menu settings updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.hideButtons();
          }
        });
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Settings/familyContent.vue